import { render, staticRenderFns } from "./NeuanmeldungenAdressenCard.vue?vue&type=template&id=781aeb3c&scoped=true"
import script from "./NeuanmeldungenAdressenCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NeuanmeldungenAdressenCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NeuanmeldungenAdressenCard.vue?vue&type=style&index=0&id=781aeb3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781aeb3c",
  null
  
)

export default component.exports